.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  max-width: 720px;
  margin: 0 auto;
  padding: var(--tuna-spacing-4);
}

.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-6);
  text-align: center;
}

.title {
  font-size: var(--tuna-font-size-4);
  margin: 0;
}

.intro {
  margin: 0;
  max-width: 420px;
  font-size: var(--tuna-font-size-1);
  color: var(--tuna-color-text-subtle);
}

.startButton {
  padding: var(--tuna-spacing-2) var(--tuna-spacing-5);
  font-weight: 600;
  font-size: var(--tuna-font-size-1);
}
